import type { IconProps as Props } from './types';

export const IconLocationPin = ({
  width = '1em',
  height = '1em',
  title = 'Location Pin Icon',
  fill = 'var(--text-link)',
  ...rest
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title>{title}</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.05 3.05a7 7 0 1 1 9.9 9.9L10 18.9l-4.95-5.95a7.001 7.001 0 0 1 0-9.9ZM10 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      fill={fill}
    />
  </svg>
);

export const IconLocationPinOutline = ({
  width = '20px',
  height = '20px',
  stroke = 'var(--text-neutral)',
  ...rest
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.7138 13.8808L11.178 17.4167C11.0234 17.5715 10.8398 17.6942 10.6376 17.778C10.4355 17.8618 10.2189 17.9049 10.0001 17.9049C9.7813 17.9049 9.56466 17.8618 9.36254 17.778C9.16043 17.6942 8.97681 17.5715 8.82218 17.4167L5.28551 13.8808C4.3532 12.9485 3.71829 11.7606 3.46108 10.4674C3.20388 9.17419 3.33592 7.83376 3.84051 6.61561C4.34511 5.39745 5.19959 4.35628 6.29591 3.62376C7.39223 2.89123 8.68115 2.50024 9.99968 2.50024C11.3182 2.50024 12.6071 2.89123 13.7034 3.62376C14.7998 4.35628 15.6542 5.39745 16.1588 6.61561C16.6634 7.83376 16.7955 9.17419 16.5383 10.4674C16.2811 11.7606 15.6462 12.9485 14.7138 13.8808Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4997 9.16667C12.4997 9.82971 12.2363 10.4656 11.7674 10.9344C11.2986 11.4033 10.6627 11.6667 9.99968 11.6667C9.33664 11.6667 8.70075 11.4033 8.23191 10.9344C7.76307 10.4656 7.49968 9.82971 7.49968 9.16667C7.49968 8.50363 7.76307 7.86774 8.23191 7.3989C8.70075 6.93006 9.33664 6.66667 9.99968 6.66667C10.6627 6.66667 11.2986 6.93006 11.7674 7.3989C12.2363 7.86774 12.4997 8.50363 12.4997 9.16667Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
